// See https://console.cloud.google.com/apis/credentials/key/84?project=embarkvet
// Use the same key on all environments (dev, test, qa, prod)
export const GOOGLE_MAPS_API_KEY = 'AIzaSyD0e1rkRbZ9VzFYd7Qpr-ZCdzdaRXRNbtA';
